import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimeBuildPage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Construction d'un runtime et son journal (porting README #42). */
export const Route = createFileRoute('/$tenant/runtimes/$runtimeId/builds/$buildId')({
  component: RuntimeBuildRoute,
});

function RuntimeBuildRoute() {
  const { tenant, runtimeId, buildId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[
        { label: t('nav.items.runtimes') },
        { label: <EntityName tenantId={tenant} kind="runtime" id={runtimeId} /> },
        { label: <EntityName tenantId={tenant} kind="runtimeBuild" id={buildId} scope={{ runtimeId }} /> },
      ]}
    >
      <RuntimeBuildPage tenantId={tenant} runtimeId={runtimeId} buildId={buildId} />
    </ConsoleShell>
  );
}
